// extracted by mini-css-extract-plugin
export var emailBlockLink = "_hp-0";